module.exports = __webpack_public_path__ + "static/img/fayuan-icon8.15642502.png";